/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { doctorsControllerCreate } from '../fn/doctors/doctors-controller-create';
import { DoctorsControllerCreate$Params } from '../fn/doctors/doctors-controller-create';
import { doctorsControllerDelete } from '../fn/doctors/doctors-controller-delete';
import { DoctorsControllerDelete$Params } from '../fn/doctors/doctors-controller-delete';
import { doctorsControllerFilter } from '../fn/doctors/doctors-controller-filter';
import { DoctorsControllerFilter$Params } from '../fn/doctors/doctors-controller-filter';
import { doctorsControllerFindOne } from '../fn/doctors/doctors-controller-find-one';
import { DoctorsControllerFindOne$Params } from '../fn/doctors/doctors-controller-find-one';
import { doctorsControllerReactivate } from '../fn/doctors/doctors-controller-reactivate';
import { DoctorsControllerReactivate$Params } from '../fn/doctors/doctors-controller-reactivate';
import { doctorsControllerUpdate } from '../fn/doctors/doctors-controller-update';
import { DoctorsControllerUpdate$Params } from '../fn/doctors/doctors-controller-update';
import { ResponseDoctorDto } from '../models/response-doctor-dto';

@Injectable({ providedIn: 'root' })
export class DoctorsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `doctorsControllerCreate()` */
  static readonly DoctorsControllerCreatePath = '/thalea-doctors/doctors';

  /**
   * Create a doctor.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorsControllerCreate$Response(params: DoctorsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseDoctorDto>> {
    return doctorsControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a doctor.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorsControllerCreate(params: DoctorsControllerCreate$Params, context?: HttpContext): Observable<ResponseDoctorDto> {
    return this.doctorsControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseDoctorDto>): ResponseDoctorDto => r.body)
    );
  }

  /** Path part for operation `doctorsControllerFindOne()` */
  static readonly DoctorsControllerFindOnePath = '/thalea-doctors/doctors/{tenant}/{id}';

  /**
   * Find a doctor by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorsControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorsControllerFindOne$Response(params: DoctorsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseDoctorDto>> {
    return doctorsControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Find a doctor by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorsControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorsControllerFindOne(params: DoctorsControllerFindOne$Params, context?: HttpContext): Observable<ResponseDoctorDto> {
    return this.doctorsControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseDoctorDto>): ResponseDoctorDto => r.body)
    );
  }

  /** Path part for operation `doctorsControllerUpdate()` */
  static readonly DoctorsControllerUpdatePath = '/thalea-doctors/doctors/{tenant}/{id}';

  /**
   * Update a doctor.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorsControllerUpdate$Response(params: DoctorsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseDoctorDto>> {
    return doctorsControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a doctor.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorsControllerUpdate(params: DoctorsControllerUpdate$Params, context?: HttpContext): Observable<ResponseDoctorDto> {
    return this.doctorsControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseDoctorDto>): ResponseDoctorDto => r.body)
    );
  }

  /** Path part for operation `doctorsControllerDelete()` */
  static readonly DoctorsControllerDeletePath = '/thalea-doctors/doctors/{tenant}/{id}';

  /**
   * Delete a doctor.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorsControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorsControllerDelete$Response(params: DoctorsControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return doctorsControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a doctor.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorsControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorsControllerDelete(params: DoctorsControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.doctorsControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `doctorsControllerReactivate()` */
  static readonly DoctorsControllerReactivatePath = '/thalea-doctors/doctors/{tenant}/{id}/reactivate';

  /**
   * Reactivate a doctor.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorsControllerReactivate()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorsControllerReactivate$Response(params: DoctorsControllerReactivate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return doctorsControllerReactivate(this.http, this.rootUrl, params, context);
  }

  /**
   * Reactivate a doctor.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorsControllerReactivate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorsControllerReactivate(params: DoctorsControllerReactivate$Params, context?: HttpContext): Observable<void> {
    return this.doctorsControllerReactivate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `doctorsControllerFilter()` */
  static readonly DoctorsControllerFilterPath = '/thalea-doctors/doctors/filter';

  /**
   * Filter doctors based on query parameters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorsControllerFilter()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorsControllerFilter$Response(params: DoctorsControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseDoctorDto>>> {
    return doctorsControllerFilter(this.http, this.rootUrl, params, context);
  }

  /**
   * Filter doctors based on query parameters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorsControllerFilter$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorsControllerFilter(params: DoctorsControllerFilter$Params, context?: HttpContext): Observable<Array<ResponseDoctorDto>> {
    return this.doctorsControllerFilter$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponseDoctorDto>>): Array<ResponseDoctorDto> => r.body)
    );
  }

}
